import { createFileRoute } from '@tanstack/react-router';
import Tabular from 'src/pages/Organization/Blueprints/Tabular';

export const Route = createFileRoute('/$organizationSlug/blueprints/tabular/')({
  component: Tabular,
});
